import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "border-box mb-3 p-4" }
const _hoisted_8 = { class: "row mb-0" }
const _hoisted_9 = { class: "col-1" }
const _hoisted_10 = ["href"]

import { ref, computed, onMounted, watch } from 'vue'
    import { useId } from '@common/composables'
    import { useRouter } from 'vue-router'
    import { useAdminDatasetsDetailsPage } from '@Integrations/Datasets/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminDatasetDetailsPage',
  setup(__props) {

    const router = useRouter()
    const id = useId()

    const {
        useCurrentUserQuery,
        useDatasetDetailsQuery,
        useDatasetChangeLogQueryV1,
        useClearDatasetItemsCommand,
        useDeleteDatasetCommand,
        usePermanentDeleteDatasetCommand,
    } = useAdminDatasetsDetailsPage()

    const showApi = ref(false)

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelDatasetDetailsQueryV1, runDatasetDetailsQueryV1 } = useDatasetDetailsQuery(id)
    const tid = computed(() => modelDatasetDetailsQueryV1.value?.OrganizationUnitId)
    const name = computed(() => modelDatasetDetailsQueryV1.value?.Name)
    const data = computed(() => modelDatasetDetailsQueryV1.value?.Data)
    const isDeleted = computed(() => modelDatasetDetailsQueryV1.value?.IsDeleted)

    const { modelDatasetChangeLogQueryV1, runDatasetChangeLogQueryV1 } = useDatasetChangeLogQueryV1(id)
    const changes = computed(() => modelDatasetChangeLogQueryV1.value?.Changes || [])
    const changesReversed = computed(() => changes.value.reverse())

    const { invokeClearDatasetItemsCommandV1, succeedClearDatasetItemsCommandV1 } = useClearDatasetItemsCommand(id, tid, userId)

    const { invokeDeleteDatasetCommandV1, succeedDeleteDatasetCommandV1 } = useDeleteDatasetCommand(id, tid, userId)
    const { invokePermanentDeleteDatasetCommandV1, succeedPermanentDeleteDatasetCommandV1 } = usePermanentDeleteDatasetCommand(id)

    function handleClearDatasetItemsCommandV1() {
        if (confirm('Do you want to clear all dataset items permenently?')) {
            invokeClearDatasetItemsCommandV1()
        }
    }

    function handleDeleteDatasetCommandV1() {
        if (confirm(`Do you really want to delete dataset ${name.value}?`)) invokeDeleteDatasetCommandV1()
    }

    function handlePermanentDeleteDatasetCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete dataset ${name.value}?`)) invokePermanentDeleteDatasetCommandV1()
    }

    onMounted(() => {
        runCurrentUserQueryV1()
        runDatasetDetailsQueryV1()
        runDatasetChangeLogQueryV1()
    })

    watch(name, () => document.title = name.value)

    watch([succeedClearDatasetItemsCommandV1, succeedDeleteDatasetCommandV1], () => runDatasetDetailsQueryV1())

    watch(succeedPermanentDeleteDatasetCommandV1, (val) => val ? router.push(`/admin/integrations/datasets/manage/${tid.value}`) : null)

return (_ctx: any,_cache: any) => {
  const _component_json_viewer = _resolveComponent("json-viewer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(name.value), 1 /* TEXT */),
          (!isDeleted.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: handleClearDatasetItemsCommandV1,
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", {
                  class: "fa fa-eraser",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" Clear dataset ", -1 /* CACHED */)
              ]))]))
            : _createCommentVNode("v-if", true),
          (!isDeleted.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: handleDeleteDatasetCommandV1,
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "fa-regular fa-trash-can" }, null, -1 /* CACHED */),
                _createTextVNode(" Delete ", -1 /* CACHED */)
              ]))]))
            : (_openBlock(), _createElementBlock("a", {
                key: 2,
                onClick: handlePermanentDeleteDatasetCommandV1,
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("i", {
                  class: "fa fa-remove",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" Permanently delete ", -1 /* CACHED */)
              ]))]))
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[25] || (_cache[25] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-11" }, [
            _createElementVNode("h5", { class: "m-0" }, "REST API")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("a", {
              role: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showApi.value=true))
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fa-solid fa-chevron-down" }, null, -1 /* CACHED */)
            ]))], 512 /* NEED_PATCH */), [
              [_vShow, !showApi.value]
            ]),
            _withDirectives(_createElementVNode("a", {
              role: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showApi.value=false))
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", { class: "fa-solid fa-chevron-up" }, null, -1 /* CACHED */)
            ]))], 512 /* NEED_PATCH */), [
              [_vShow, showApi.value]
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Authorization: API Key (AccessToken = YOUR_ACCESS_TOKEN)", -1 /* CACHED */)),
          _cache[23] || (_cache[23] = _createElementVNode("a", {
            href: "/#/organizations/accesstokens/my",
            target: "_blank"
          }, "My Access Tokens", -1 /* CACHED */)),
          _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
          _createElementVNode("p", null, [
            _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Get all items in dataset", -1 /* CACHED */)),
            _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createTextVNode(" GET /integrations/api/datasets/2024-10-24/" + _toDisplayString(_unref(id)) + "/data ", 1 /* TEXT */)
          ]),
          _createElementVNode("p", null, [
            _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Get signle item from dataset", -1 /* CACHED */)),
            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createTextVNode(" GET /integrations/api/datasets/2024-10-24/" + _toDisplayString(_unref(id)) + "/data/{ID_PROPERTY_NAME}/{ID} ", 1 /* TEXT */)
          ]),
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Add item to dataset", -1 /* CACHED */)),
            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createTextVNode(" POST /integrations/api/datasets/2024-10-24/" + _toDisplayString(_unref(id)) + "/data/{ID_PROPERTY_NAME}/{ID} ", 1 /* TEXT */),
            _cache[15] || (_cache[15] = _createElementVNode("pre", null, "{\n    \"Name\": \"My Project 123\",\n    \"Description\": \"My project description\"\n}\n", -1 /* CACHED */))
          ]),
          _createElementVNode("div", null, [
            _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Update item in dataset", -1 /* CACHED */)),
            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createTextVNode(" PUT /integrations/api/datasets/2024-10-24/" + _toDisplayString(_unref(id)) + "/data/{ID_PROPERTY_NAME}/{ID} ", 1 /* TEXT */),
            _cache[18] || (_cache[18] = _createElementVNode("pre", null, "{\n    \"Description\": \"My project NEW description\"\n}\n", -1 /* CACHED */))
          ]),
          _createElementVNode("p", null, [
            _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Delete item from dataset", -1 /* CACHED */)),
            _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createTextVNode(" DELETE /integrations/api/datasets/2024-10-24/" + _toDisplayString(_unref(id)) + "/data/{ID_PROPERTY_NAME}/{ID} ", 1 /* TEXT */)
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, showApi.value]
        ])
      ]),
      _createElementVNode("strong", null, "Items: " + _toDisplayString(data.value?.length ?? 0), 1 /* TEXT */),
      (data.value)
        ? (_openBlock(), _createBlock(_component_json_viewer, {
            key: 0,
            value: data.value,
            "expand-depth": 1,
            expanded: "",
            copyable: "",
            boxed: "",
            sort: ""
          }, null, 8 /* PROPS */, ["value"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changesReversed.value, (c) => {
          return (_openBlock(), _createElementBlock("li", null, [
            _createTextVNode(_toDisplayString(c.Details) + " ", 1 /* TEXT */),
            _createElementVNode("a", {
              href: `/#/admin/integrations/runs/details/${tid.value}/${c.RunId}`
            }, "Run", 8 /* PROPS */, _hoisted_10)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ]))
}
}

})